import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    transactieAantal: null,
    gemiddeldeCourtage: 1.5,

    resultShown: false,

    result: {
      views: 0,
      clicks: 0,
      leads: 0,
      markt: 0,
      eigenAanbod: 0,

      bezichtigingen: 0,
      aankoopadvies: 0,
      verkoopadvies: 0,
      hypotheekadvies: 0,

      budget: 0,
      totaalOpbrengst: 0
    }
  },
  mutations: {
    setTransactieAantal(state, value) {
      state.transactieAantal = value;
    },
    setGemiddeldeCourtage(state, value) {
      state.gemiddeldeCourtage = value;
    },
    setResultShown(state, value) {
      state.resultShown = value;
    },
    setResults(state, value) {
      state.result = value;
    }
  },
  actions: {
    calculate({ state, commit }) {
      let gemiddeldeWoningsWaarde = 300000;
      let result = state.result;
      let advertentieKosten = state.transactieAantal * 20;
      let productKosten = 3914.28;

      result.views =
        2532 * state.transactieAantal + 2561.46 * state.transactieAantal;
      result.clicks =
        84 * state.transactieAantal + 364.32 * state.transactieAantal;
      result.leads = advertentieKosten / 25;
      result.markt = result.leads * 0.25;
      result.eigenAanbod = result.leads * 0.1;

      let advertentieOpbrengsten =
        ((gemiddeldeWoningsWaarde * state.gemiddeldeCourtage) / 100) *
          result.eigenAanbod -
        advertentieKosten;

      result.bezichtigingen = state.transactieAantal * 10;
      result.aankoopadvies = result.bezichtigingen * 0.05;
      result.verkoopadvies = result.bezichtigingen * 0.03;
      result.hypotheekadvies = result.bezichtigingen * 0.02;

      let productOpbrengsten =
        result.aankoopadvies * 2500 +
        result.verkoopadvies * 2750 +
        result.hypotheekadvies * 2250;

      result.budget = advertentieKosten + productKosten;
      result.totaalOpbrengst = advertentieOpbrengsten + productOpbrengsten;

      commit("setResults", result);
      commit("setResultShown", true);
    }
  },
  modules: {}
});
